import React from 'react';
import { Search, Calendar, Users, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSearch() {
  return <motion.div initial={{
    y: 20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    delay: 0.2
  }} className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-4 md:p-6 relative z-20 border border-gray-100" data-id="element-130">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4" data-id="element-131">
        {/* Location */}
        <div className="md:col-span-4 relative group" data-id="element-132">
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1 ml-1" data-id="element-133">
            Destination
          </label>
          <div className="relative bg-gray-50 rounded-xl hover:bg-white hover:ring-2 hover:ring-travel-blue-500/20 transition-all duration-200 border border-transparent hover:border-travel-blue-200" data-id="element-134">
            <MapPin className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-travel-blue-500" data-id="element-135" />
            <input type="text" placeholder="Search City, Packages, Tourist Attractions" className="w-full bg-transparent pl-12 pr-4 py-4 rounded-xl outline-none text-gray-900 font-medium placeholder:text-gray-400" data-id="element-136" />
          </div>
        </div>

        {/* Dates */}
        <div className="md:col-span-3 relative group" data-id="element-137">
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1 ml-1" data-id="element-138">
            Start Date
          </label>
          <div className="relative bg-gray-50 rounded-xl hover:bg-white hover:ring-2 hover:ring-travel-blue-500/20 transition-all duration-200 border border-transparent hover:border-travel-blue-200" data-id="element-139">
            <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-travel-blue-500" data-id="element-140" />
            <input type="text" placeholder="Select Date" className="w-full bg-transparent pl-12 pr-4 py-4 rounded-xl outline-none text-gray-900 font-medium placeholder:text-gray-400" onFocus={e => e.target.type = 'date'} onBlur={e => e.target.type = 'text'} data-id="element-141" />
          </div>
        </div>

        {/* Guests */}
        <div className="md:col-span-3 relative group" data-id="element-142">
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1 ml-1" data-id="element-143">
            Number Of People
          </label>
          <div className="relative bg-gray-50 rounded-xl hover:bg-white hover:ring-2 hover:ring-travel-blue-500/20 transition-all duration-200 border border-transparent hover:border-travel-blue-200" data-id="element-144">
            <Users className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-travel-blue-500" data-id="element-145" />
            <select className="w-full bg-transparent pl-12 pr-4 py-4 rounded-xl outline-none text-gray-900 font-medium appearance-none cursor-pointer" data-id="element-146">
              <option data-id="element-147">1</option>
              <option data-id="element-148">2</option>
              <option data-id="element-149">3</option>
              <option data-id="element-150">4</option>
              <option data-id="element-151">5+</option>
            </select>
          </div>
        </div>

        {/* Search Button */}
        <div className="md:col-span-2 flex items-end" data-id="element-152">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-travel-blue-600 hover:bg-travel-blue-700 text-white font-bold py-4 rounded-xl shadow-lg shadow-travel-blue-600/20 hover:shadow-travel-blue-600/30 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-153">
            <Search className="w-5 h-5" data-id="element-154" />
            <span data-id="element-155">Search</span>
          </motion.button>
        </div>
      </div>
    </motion.div>;
}